import Vue from "vue";
import SvgIcon from "@/components/SvgIcon/index.vue";

Vue.component("SvgIcon", SvgIcon);

// 自动导入 icons 目录下的 SVG 文件
const req = require.context("@/assets/svgIcons", true, /\.svg$/);
req.keys().forEach(req);
